"use client";

import PropTypes from "prop-types";
import Script from "next/script";
import { useEffect } from "react";
import PostHogPageView from "components/PostHogPageView";
import { useCookieContext } from "context/CookieContext";

function usePixelTracking() {
  const { isOptedOut } = useCookieContext();

  useEffect(() => {
    const src = "https://appsignal.com/cookie_consent.gif";
    const img = document.createElement("img");

    img.src = src;
    img.height = "1";
    img.width = "1";
    img.style.display = "none";

    document.body.appendChild(img);
    return () => {
      document.body.removeChild(img);
    };
  }, [isOptedOut]);
}
export function Analytics() {
  if (process.env.NODE_ENV !== "production") return null;
  const { isOptedOut } = useCookieContext();

  usePixelTracking();

  return (
    <>
      {!isOptedOut && <PostHogPageView />}

      <Script src="/js/pixel.js" strategy="afterInteractive" />
    </>
  );
}

Analytics.propTypes = {
  posthog: PropTypes.object.isRequired,
};
